// extracted by mini-css-extract-plugin
export default {"input":"AddStudentForm_input__HOL7C"};